<template>
    <Head title="Login" />
    <div class="min-h-screen flex">
        <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
            <div class="mx-auto w-full max-w-sm lg:w-96">
                <div>
                    <span class="font-bold text-gray-400 text-4xl flex justify-center lg:justify-start">
                        <logo class="h-12 w-auto inline"/>
                    </span>
                    <h2 class="mt-6 text-3xl font-thin text-gray-900">Welcome Back!</h2>
                    <p class="mt-8 text-sm text-gray-600">
                        Please use your office E-mail address to log in to this system. If you have not yet been provided a login credential, please contact your supervisor 🤗
                    </p>
                </div>

                <div class="mt-6">
                    <form class="space-y-6" @submit.prevent="login">
                        <text-input v-model="form.email" :error="form.errors.email" name="email" label="Email address" type="email" autofocus required="" placeholder="you@reethifoto.com">
                            <MailIcon class="h-6 text-gray-500"/>
                        </text-input>
                        <text-input icon="padlock-locked" class="space-y-1" v-model="form.password" :error="form.errors.password" name="password" label="Password" type="password" required="" autocomplete="current-password" placeholder="Please enter your password">
                            <KeyIcon class="h-6 text-gray-500"/>
                        </text-input>

                        <div class="flex items-center justify-between">
                            <div class="flex items-center">
                                <input id="remember-me" name="remember-me" type="checkbox" v-model="form.remember" class="h-4 w-4 text-reethi-purple focus:ring-reethi-purple accent-reethi-purple border-gray-300 rounded" />
                                <label for="remember-me" class="ml-2 block text-sm text-gray-900"> Remember me </label>
                            </div>

                            <div class="text-sm">
                                <a href="#" class="font-medium text-orange-500 hover:text-reethi-purple"> Forgot your password? </a>
                            </div>
                        </div>

                        <div class="flex flex-row">
                            <Link
                                method="get"
                                :href="this.$route('register')"
                                class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium border border-gray-300 bg-white hover:border-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Register New Account
                            </Link>
                            <span class="flex flex-grow"></span>
                            <loading-button :loading="form.processing" class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-reethi-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" type="submit">Sign In</loading-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="hidden lg:block relative w-0 flex-1">
            <login-banner class="absolute inset-0 h-full w-full object-cover" />
        </div>
    </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import { Head } from '@inertiajs/inertia-vue3'
import { Link } from '@inertiajs/inertia-vue3'
import LoginBanner from '@/Pages/Auth/LoginBanner'
import LoadingButton from '@/Shared/LoadingButton'

import {
    KeyIcon,
    MailIcon,
} from '@heroicons/vue/outline'

export default {
    components: {
        Head,
        Logo,
        Link,
        KeyIcon,
        MailIcon,
        TextInput,
        LoginBanner,
        LoadingButton,
    },
    data() {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false,
                fingerprint: {}
            }),
        }
    },
    async mounted() {
        this.form.fingerprint = await this.$fpjs.getVisitorData({extendedResult: true});
    },
    methods: {
        login() {
            this.form.post(this.$route('login.store'))
        },
    },
}
</script>
